import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnUserOrganization extends SnModel {
  @Expose()
  public id?: string;

  @Expose()
  public firstName?: string;

  @Expose()
  public lastName?: string;

  @Expose()
  public email?: string;

  @Expose()
  public mobilePhone?: string;

  @Expose()
  public address?: string;

  @Expose()
  public city?: string;

  @Expose()
  public zip?: number;

  @Expose()
  public state?: string;

  @ExposeRawData()
  public geometry?: Point;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
